module.exports = __webpack_public_path__ + "static/media/straven_2.b226f838.jpg";